export const initToggleVoucherInfo = () => {
    const voucherInfoTogglerElement = document.getElementById('voucher-info-toggler');

    if (!voucherInfoTogglerElement) {
        return;
    }

    voucherInfoTogglerElement.addEventListener('click', () => {
        const voucherInfoTextElement = document.getElementById('voucher-info-text');
        voucherInfoTogglerElement.style.display = 'none';
        if (voucherInfoTextElement) {
            voucherInfoTextElement.style.display = 'block';
        }
    });
};
